;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('PrintShopService', printShopService)

  /* @ngInject */
  function printShopService (ConnectorWebService, CONSTANTS, Utils) {
    const service = {
      getPrintShops,
      createPrintShop,
      updatePrintShop,
      deletePrintShop,
      getPrintShopsByArt,
      sendToPrintShop,
      getPrintShopById
    }

    return service

    function getPrintShops () {
      return ConnectorWebService.get(CONSTANTS.URL_PRINT_SHOPS)
    }

    function createPrintShop (payload) {
      return ConnectorWebService.post(CONSTANTS.URL_PRINT_SHOPS, payload)
    }

    function updatePrintShop (id, payload) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRINT_SHOPS_ID, [id])

      return ConnectorWebService.put(url, payload)
    }

    function deletePrintShop (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRINT_SHOPS_ID, [id])

      return ConnectorWebService.fnDelete(url)
    }

    function getPrintShopsByArt (artId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRINT_SHOPS_ART_ID, [artId])

      return ConnectorWebService.get(url)
    }

    function sendToPrintShop (artId, payload) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRINT_SHOPS_ART_ID, [artId])

      return ConnectorWebService.post(url, payload)
    }

    function getPrintShopById (printShopId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRINT_SHOPS_ID, [printShopId])

      return ConnectorWebService.get(url)
    }
  }
})()
